import { useAuth0 } from '@auth0/auth0-react';
import { ROUTER_NAME } from '@consts';
import { useGoalRecommendationsService } from '@hooks/useGoalRecommendationsService';
import * as Sentry from '@sentry/nextjs';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import BottomNavBar from './BottomNavBar';

export default function LayoutMobile({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const { isAuthenticated } = useAuth0();
  const { getGoalsRecommendationsCount } = useGoalRecommendationsService();
  const [goalsRecommendationsCount, setGoalsRecommendationsCount] = useState<number>(0);

  const isEmbedded = useMemo(() => {
    return router.query.embed?.toString().toLowerCase().trim() === 'true';
  }, [router.query.embed]);

  useEffect(() => {
    if (!isAuthenticated) {
      setGoalsRecommendationsCount(0);
      return;
    }

    if (isAuthenticated) {
      getGoalsRecommendationsCount('count')
        .then((response) => {
          setGoalsRecommendationsCount(response.count);
        })
        .catch((error) => {
          Sentry.captureException(error);
          setGoalsRecommendationsCount(0);
        });
    }
  }, [isAuthenticated]);

  const showBottomNavBar = useMemo(() => {
    if (isEmbedded) return false;
    return (
      router.pathname === ROUTER_NAME.HOME ||
      router.pathname === ROUTER_NAME.EXPLORE ||
      router.pathname === ROUTER_NAME.CONVERSATIONS ||
      router.pathname === ROUTER_NAME.GARMIN_CONNECTIONS ||
      router.pathname === ROUTER_NAME.GARMIN_CONNECTION_AUTHORIZE ||
      router.pathname === ROUTER_NAME.TASKS ||
      router.pathname === ROUTER_NAME.GOAL_SUBSCRIPTIONS ||
      router.pathname === ROUTER_NAME.GOALS ||
      router.pathname === ROUTER_NAME.MESSAGES
    );
  }, [router.pathname, isEmbedded]);

  return (
    <div className='h-dvh w-full overflow-hidden flex flex-col'>
      <div className='flex-1 overflow-hidden min-h-0'>{children}</div>
      {showBottomNavBar && <BottomNavBar goalsRecommendationsCount={goalsRecommendationsCount} />}
    </div>
  );
}
